import React from 'react';
import { Box, Button, Dropdown, Select, Checkbox, Image, Alert, Typography, Grid, TextField, Calendar } from '@iho-design-system/Loader';
import moment from 'jalali-moment';

//import { FiEye, FiEyeOff } from 'react-icons/fi'; // Import the eye icons


import CalendarSVG from '../../assets/images/icons/calendar.svg';
import profileImg from '../../assets/images/icons/user-profile.svg';
import iconDownSVG from '../../assets/images/icons/chevron-down.svg';
import getAPI from './../../api/get';
import AgencyProfile from '../../api/edit/AgencyProfile';
import eye from './../../assets/images/icons/observer.svg';



export default function ChangePass() {
    const [CurrentPassword, setCurrentPassword] = React.useState('')
    const [NewPassword, setNewPassword] = React.useState('')
    const [ConfirmNewPassword, setConfirmNewPassword] = React.useState('')
    const typeUser = localStorage.getItem('userType');
    const [showCurrentPassword, setShowCurrentPassword] = React.useState(false); // State for showing/hiding current password
    const [showNewPassword, setShowNewPassword] = React.useState(false); // State for showing/hiding new password
    const [showConfirmNewPassword, setShowConfirmNewPassword] = React.useState(false); // State for showing/hiding confirm new password
    const [validationErrors, setValidationErrors] = React.useState({
        currentPassword: false,
        newPassword: false,
        confirmNewPassword: false
    });

    /*
       - alert
   */
    const [alert, setAlert] = React.useState('');
    const [alertColor, setAlertColor] = React.useState('success');
    const [alertStatus, setAlertStatus] = React.useState('d-none');
    const alertProps = (config) => {
        setAlert(config[1])
        setAlertColor(config[0]);
        setAlertStatus('d-flex');
        setTimeout(() => {
            setAlertStatus('d-none');
        }, 3000);
    }
    const handleSubmit = async (e) => {
        e.preventDefault();
        let method = 'ChangePassword';
        let pattern = /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d@.]{8,}$/;


        if (!CurrentPassword || !NewPassword || !ConfirmNewPassword) {
            setValidationErrors({
                currentPassword: !CurrentPassword,
                newPassword: !NewPassword,
                confirmNewPassword: !ConfirmNewPassword
            });
            alertProps(['danger', 'لطفاً تمامی فیلدها را پر کنید']);
            return;
        }
        else {
            setValidationErrors({
                currentPassword: false,
                newPassword: false,
                confirmNewPassword: false
            });
        }

        if (NewPassword !== ConfirmNewPassword) {
            setValidationErrors({
                currentPassword: false,
                newPassword: true,
                confirmNewPassword: true
            });
            alertProps(['danger', 'رمز عبور جدید و تکرار آن باید یکسان باشند']);
            return;
        }
        else {
            setValidationErrors({
                currentPassword: false,
                newPassword: false,
                confirmNewPassword: false
            });
        }



        if (NewPassword.length < 6) {
            setValidationErrors({
                currentPassword: false,
                newPassword: true,
                confirmNewPassword: false
            });
            alertProps(['danger', 'رمز عبور باید حداقل شامل 6 کاراکتر باشد']);
            return;

        } else {
            setValidationErrors({
                currentPassword: false,
                newPassword: false,
                confirmNewPassword: false
            });
        }
        let dataPass = {
            CurrentPassword: CurrentPassword,
            NewPassword: NewPassword,
            ConfirmNewPassword: ConfirmNewPassword

        }
        let result = await AgencyProfile(method, dataPass);

        if (result.status === 'success') {
            alertProps(['success', 'با موفقیت ثبت شد']);

        } else {
            if (result.data.Errors) {
                alertProps(['danger', result.data.Errors.toString()]);

            } else {

                alertProps(['danger', result.data.Message]);
            }
        }
    }
    const editPass = (type, value) => {
        switch (type) {
            case 'oldPass':
                setCurrentPassword(value);
                // setValidationErrors({ ...validationErrors, currentPassword: false });
                break;
            case 'NewPass':
                setNewPassword(value);
                //    setValidationErrors({ ...validationErrors, newPassword: false });

                break;
            case 'matchPass':
                setConfirmNewPassword(value);
                // setValidationErrors({ ...validationErrors, confirmNewPassword: false });

                break;

            default:
                break;
        }
    }
    const resetForm = () => {
        setCurrentPassword('');
        setNewPassword('');
        setConfirmNewPassword('');
    }
    return (
        <React.Fragment>
            <form onSubmit={handleSubmit}
                method="POST"  >
                <Box
                    className={`bg-white rounded-lg border-solid border-light p-xl`}>

                    <Grid>
                        <Grid.Wrapper>
                            <Grid.Item
                                size='col-7'>
                                <Grid.Wrapper>
                                    <Grid.Item
                                        className={`border-solid-bottom border-light`}
                                        size='col-12'>
                                        <Typography ms={{
                                            fontWeight: 'bold'
                                        }}>
                                            تغییر رمز عبور
                                        </Typography>
                                    </Grid.Item>

                                    <Grid.Item
                                        size='col-12' ms={{ position: 'relative' }}>

                                        <TextField
                                            ms={{
                                                fontSize: '12px'
                                            }}
                                            type={showCurrentPassword ? 'text' : 'password'} onChange={(event) => editPass('oldPass', event)}
                                            // error={validationErrors.currentPassword}
                                            className={validationErrors.currentPassword ? 'border-red' : ''}
                                            value={CurrentPassword}
                                            label='  رمز عبور فعلی '

                                        />


                                        {showCurrentPassword ?
                                            <Image src={eye}
                                                onClick={() => setShowCurrentPassword(false)}
                                                ms={{
                                                    width: '20px',
                                                    position: 'absolute',
                                                    left: '15px',
                                                    zIndex: '10',
                                                    top: '12px',
                                                }} /> :
                                            <Image src={eye}
                                                onClick={() => setShowCurrentPassword(true)}
                                                ms={{
                                                    width: '20px',
                                                    position: 'absolute',
                                                    left: '15px',
                                                    zIndex: '10',
                                                    top: '12px',
                                                }} />}

                                    </Grid.Item>
                                    <Grid.Item
                                        size='col-12' ms={{ position: 'relative' }}>

                                        <TextField
                                            ms={{
                                                fontSize: '12px'
                                            }}
                                            value={NewPassword}
                                            label=' رمز عبور جدید'
                                            className={validationErrors.newPassword ? 'border-red' : ''}


                                            type={showNewPassword ? 'text' : 'password'}
                                            onChange={(event) => editPass('NewPass', event)}

                                        />

                                        {showNewPassword ?
                                            <Image
                                                onClick={() => setShowNewPassword(false)}
                                                src={eye}
                                                ms={{
                                                    width: '20px',
                                                    position: 'absolute',
                                                    left: '15px',
                                                    zIndex: '10',
                                                    top: '12px',
                                                }} /> :
                                            <Image
                                                onClick={() => setShowNewPassword(true)}
                                                src={eye} ms={{
                                                    width: '20px',
                                                    position: 'absolute',
                                                    left: '15px',
                                                    zIndex: '10',
                                                    top: '12px',
                                                }} />}

                                    </Grid.Item>
                                    <Grid.Item
                                        size='col-12' ms={{ position: 'relative' }}>

                                        <TextField
                                            ms={{
                                                fontSize: '12px'
                                            }}
                                            value={ConfirmNewPassword}
                                            label=' تکرار رمز عبور جدید'
                                            type={showConfirmNewPassword ? 'text' : 'password'}
                                            onChange={(event) => editPass('matchPass', event)}
                                            className={validationErrors.confirmNewPassword ? 'border-red' : ''}


                                        />

                                        {showConfirmNewPassword ?
                                            <Image src={eye}
                                                onClick={() => {

                                                    setShowConfirmNewPassword(false)
                                                }}
                                                ms={{
                                                    width: '20px',
                                                    position: 'absolute',
                                                    left: '15px',
                                                    zIndex: '10',
                                                    top: '12px',
                                                }} /> :
                                            <Image src={eye}
                                                onClick={() => setShowConfirmNewPassword(true)}
                                                ms={{
                                                    width: '20px',
                                                    position: 'absolute',
                                                    left: '15px',
                                                    zIndex: '10',
                                                    top: '12px',
                                                }} />}

                                    </Grid.Item>

                                </Grid.Wrapper>
                            </Grid.Item>
                            <Grid.Item
                                size='col-5'>

                                <Image
                                    src={profileImg}
                                    ms={{
                                        background: '#F5F5F7',
                                        borderRadius: '16px',
                                        height: '290px'

                                    }}
                                />
                            </Grid.Item>
                            <Grid.Item
                                size='col-12'>
                                <Button
                                    type="submit"
                                    className={`px-lg`}
                                    ms={{
                                        padding: '8px 20px'
                                    }}
                                    variant='filled'
                                    color='primary'>
                                    ذخیره رمز عبور جدید
                                </Button>
                                <Button

                                    ms={{
                                        padding: '8px 20px'
                                    }}
                                    onClick={() => resetForm()}
                                    className={`mx-md`}
                                    variant='outlined'
                                    color='primary'>
                                    انصراف
                                </Button>
                            </Grid.Item>
                        </Grid.Wrapper>

                    </Grid>

                </Box>

            </form>
            <Alert
                className={`alert ${alertStatus}`}
                color={alertColor}
                ms={{
                    bottom: '75px !important'
                }}>
                {alert}
            </Alert>
        </React.Fragment>
    )
}
